<template>
  <div>
    <breadcrumbs
      :breadcrumb-items="breadcrumbItems"
    />
    <b-card>
      <div class="head-card">
        <DspPartnerToolbar
          v-if="Object.keys(dsppartner).length !== 0"
          :dsppartner="dsppartner"
          closing
        />
        <hr>
      </div>
      <template
        v-if="logs.length !== 0"
      >
        <!-- Statistics Card -->
        <b-card class="mb-3">
          <b-row>
            <b-col
              cols="12"
              md="6"
            >
              <div>
                <strong>{{ $t('stats.country') }}:</strong>
              </div>
              <div class="d-flex align-items-center mt-2">
                <b-form-select
                  v-model="selectedCountry"
                  :options="countryFilterOptions"
                  :style="{ maxWidth: '200px' }"
                  :disabled="countryFilterOptions.length <= 1"
                  size="sm"
                />
                <span class="ml-2 text-muted text-lowercase">
                  {{ $t('stats.entries') }}: {{ filteredLogs.length }}
                </span>
              </div>
              <div class="mb-3">
                <div class="country-counts mt-2">
                  <div
                    v-if="Object.keys(countryCounts).length === 0"
                    class="text-muted"
                  >
                    Нет данных
                  </div>
                  <div
                    v-for="(count, country) in countryCounts"
                    v-else
                    :key="country"
                  >
                    {{ country }}: {{ count }}
                  </div>
                </div>
              </div>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <div class="mb-3">
                <strong>Bidfloor:</strong>
                <div class="mt-2">
                  <span class="mr-4">Min: {{ bidfloorStats.min.toFixed(5) }}</span>
                  <span class="mr-4">Max: {{ bidfloorStats.max.toFixed(5) }}</span>
                  <span>Avg: {{ bidfloorStats.avg.toFixed(5) }}</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <hr>
        </b-card>
        <div
          v-for="(log, index) in filteredLogs"
          :key="index"
          class="log-row mb-1"
          :class="{
            odd: index % 2 !== 0,
            even: index % 2 === 0
          }"
        >
          <p v-if="log.request.site !== undefined">
            <strong>{{ log.request.site.domain }}</strong>
          </p>
          <b-row>
            <b-col cols="8">
              <json-viewer
                :expand-depth="2"
                copyable
                boxed
                :value="log"
                @copied="copied()"
              />
            </b-col>
            <b-col cols="4">
              <div v-if="getBidData(log)">
                <div
                  v-if="getBidData(log).image"
                  class="mb-3"
                >
                  <img
                    :src="getBidData(log).image"
                    :data-original-src="getBidData(log).image"
                    alt="Ad image"
                    referrerpolicy="no-referrer"
                    style="max-width: 100%; max-height: 150px; height: auto; border: 1px solid #ddd; border-radius: 4px;"
                    @error="retryBidImage"
                  >
                </div>
                <div class="mb-25">
                  <strong>Title:</strong>
                  {{ getBidData(log).title || 'N/A' }}
                </div>
                <div class="mb-25">
                  <strong>Adomain:</strong>
                  {{ getBidData(log).adomain || 'N/A' }}
                </div>
                <div class="mb-25">
                  <strong>CID:</strong>
                  {{ getBidData(log).cid || 'N/A' }}
                </div>
                <div>
                  <strong>CRID:</strong>
                  {{ getBidData(log).crid || 'N/A' }}
                </div>
                <div
                  v-if="getNotificationUrl(log, 'burl') || getNotificationUrl(log, 'nurl')"
                  class="notification-url-decoder mt-3"
                >
                  <div class="d-flex flex-wrap">
                    <b-button
                      v-if="getNotificationUrl(log, 'burl')"
                      class="mr-1 mb-1"
                      size="sm"
                      variant="primary"
                      :disabled="isDecodingUrl(log, index, 'burl')"
                      @click="decodeNotificationUrl(log, index, 'burl')"
                    >
                      {{ $t('dsppartners.decode_burl') }}
                    </b-button>
                    <b-button
                      v-if="getNotificationUrl(log, 'nurl')"
                      class="mb-1"
                      size="sm"
                      variant="primary"
                      :disabled="isDecodingUrl(log, index, 'nurl')"
                      @click="decodeNotificationUrl(log, index, 'nurl')"
                    >
                      {{ $t('dsppartners.decode_nurl') }}
                    </b-button>
                  </div>
                  <div
                    v-if="getDecodedUrl(log, index, 'burl') !== undefined"
                    class="decoded-url-result mt-1"
                  >
                    <strong>{{ $t('dsppartners.decoded_burl') }}:</strong>
                    <pre>{{ formatDecodedUrl(getDecodedUrl(log, index, 'burl')) }}</pre>
                  </div>
                  <div
                    v-if="getDecodedUrl(log, index, 'nurl') !== undefined"
                    class="decoded-url-result mt-1"
                  >
                    <strong>{{ $t('dsppartners.decoded_nurl') }}:</strong>
                    <pre>{{ formatDecodedUrl(getDecodedUrl(log, index, 'nurl')) }}</pre>
                  </div>
                </div>
              </div>
              <div v-else>
                <p class="text-muted">
                  No bid data available
                </p>
              </div>
            </b-col>
          </b-row>
          <hr>
        </div>
      </template>
    </b-card>
  </div>
</template>
<script>
import useJwt from '@/auth/jwt/useJwt'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Breadcrumbs from '@/views/ui/breadcrumbs/Breadcrumbs.vue'
import {
  BCard,
  BRow,
  BCol,
  BButton,
  VBTooltip,
  BFormSelect,
} from 'bootstrap-vue'
import DspPartnerToolbar from './DspPartnerToolbar.vue'

export default {
  components: {
    Breadcrumbs,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormSelect,
    DspPartnerToolbar,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      loading: true,
      breadcrumbItems: [],
      dsppartner: {},
      logs: [],
      errors: [],
      filterStatus: '',
      filterOptions: [],
      selectedCountry: '',
      decodedUrls: {},
      decodingUrls: {},
    }
  },
  computed: {
    logsFormat() {
      if (!this.logs || this.logs.length === 0) {
        return []
      }
      return this.logs.map(l => {
        try {
          const obj = typeof l === 'string' ? JSON.parse(l) : l
          const { response, request } = obj
          delete obj.request
          delete obj.response
          return { ...obj, response, request }
        } catch (e) {
          return null
        }
      }).filter(log => log !== null)
    },
    bidfloorStats() {
      const bidfloors = this.filteredLogs
        .map(log => {
          if (log?.request?.imp && Array.isArray(log.request.imp)) {
            const impWithBidfloor = log.request.imp.find(impItem => impItem && typeof impItem.bidfloor === 'number' && !Number.isNaN(impItem.bidfloor))
            if (impWithBidfloor) {
              return impWithBidfloor.bidfloor
            }
          }
          return null
        })
        .filter(val => val !== null && typeof val === 'number' && !Number.isNaN(val))

      if (bidfloors.length === 0) {
        return { min: 0, max: 0, avg: 0 }
      }

      const min = Math.min(...bidfloors)
      const max = Math.max(...bidfloors)
      const avg = bidfloors.reduce((sum, val) => sum + val, 0) / bidfloors.length

      return { min, max, avg }
    },
    allCountryCounts() {
      const counts = {}
      this.logsFormat.forEach(log => {
        if (log?.request?.device?.geo?.country) {
          const { country } = log.request.device.geo
          counts[country] = (counts[country] || 0) + 1
        }
      })
      return counts
    },
    countryCounts() {
      if (this.selectedCountry) {
        const count = this.filteredLogs.length
        return count > 0 ? { [this.selectedCountry]: count } : {}
      }
      // Сортируем по имени страны
      return Object.fromEntries(
        Object.entries(this.allCountryCounts).sort(([a], [b]) => a.localeCompare(b)),
      )
    },
    countryFilterOptions() {
      const options = [{ value: '', text: this.$t('users.all') }]
      const countries = Object.keys(this.allCountryCounts).sort()
      countries.forEach(country => {
        options.push({ value: country, text: `${country} (${this.allCountryCounts[country]})` })
      })
      return options
    },
    filteredLogs() {
      if (!this.selectedCountry) {
        return this.logsFormat
      }
      return this.logsFormat.filter(log => {
        if (!log?.request?.device?.geo?.country) {
          return false
        }
        return log.request.device.geo.country === this.selectedCountry
      })
    },
  },
  watch: {
    loading(newVal) {
      if (newVal === false) {
        setTimeout(() => {
          const copyButtons = document.querySelectorAll('.jv-tooltip .jv-button')
          if (copyButtons.length) {
            copyButtons.forEach(cb => {
              cb.innerHTML = this.$t('form.copy')
            })
          }
        }, 500)
      }
    },
  },
  async created() {
    this.getDspPartnerData()
    await this.fetchLogs()
  },
  methods: {
    async fetchLogs() {
      try {
        const response = await fetch(`https://rtb-eu.phoenix-widget.com/api/v1/requests?c=${this.$route.params.id}`, {
          method: 'get',
          headers: {
            token: '8AD1dA9j3fpjD(2f1(@jfas2n91dKsd2dfbI',
          },
        })
        const data = await response.json()
        this.logs = Array.isArray(data) ? data : []
      } catch (error) {
        this.errors.push(error)
      }
      this.loading = false
    },
    copied() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: this.$t('form.copied'),
          icon: 'BellIcon',
        },
      })
    },
    getNotificationUrl(log, type) {
      const bid = log?.response?.seatbid?.[0]?.bid?.[0]
      const url = bid && bid[type]
      return typeof url === 'string' && url.trim() ? url : null
    },
    getNotificationUrlToken(url) {
      const query = url.includes('?') ? url.slice(url.indexOf('?') + 1) : url
      const equalsIndex = query.indexOf('=')
      if (equalsIndex === -1) return null

      const token = query.slice(equalsIndex + 1).split('&')[0]
      return token || null
    },
    getNotificationUrlKey(log, index, type) {
      const logId = log?.response?.id || log?.created_at || index
      return `${logId}:${index}:${type}`
    },
    getDecodedUrl(log, index, type) {
      return this.decodedUrls[this.getNotificationUrlKey(log, index, type)]
    },
    isDecodingUrl(log, index, type) {
      return Boolean(this.decodingUrls[this.getNotificationUrlKey(log, index, type)])
    },
    formatDecodedUrl(value) {
      return typeof value === 'string' ? value : JSON.stringify(value, null, 2)
    },
    async decodeNotificationUrl(log, index, type) {
      const url = this.getNotificationUrl(log, type)
      const querystring = url && this.getNotificationUrlToken(url)
      if (!querystring) return

      const key = this.getNotificationUrlKey(log, index, type)
      this.$set(this.decodingUrls, key, true)
      this.$delete(this.decodedUrls, key)

      try {
        const response = await useJwt.getDbd({ querystring })
        this.$set(this.decodedUrls, key, response.data.data)
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.message,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.$set(this.decodingUrls, key, false)
      }
    },
    retryBidImage(event) {
      const image = event.target
      const retryCount = Number(image.dataset.retryCount || 0)
      const { originalSrc } = image.dataset
      const retryDelays = [1000, 5000, 15000, 30000, 60000]

      if (!originalSrc || retryCount >= retryDelays.length) {
        image.style.display = 'none'
        return
      }

      image.dataset.retryCount = String(retryCount + 1)
      const separator = originalSrc.includes('?') ? '&' : '?'
      setTimeout(() => {
        image.src = `${originalSrc}${separator}_image_retry=${Date.now()}`
      }, retryDelays[retryCount])
    },
    getBidData(log) {
      try {
        if (!log.response || typeof log.response !== 'object' || !log.response.seatbid || !log.response.seatbid[0] || !log.response.seatbid[0].bid || !log.response.seatbid[0].bid[0]) {
          return null
        }
        const bid = log.response.seatbid[0].bid[0]
        const result = {
          cid: bid.cid || null,
          crid: bid.crid || null,
          adomain: bid.adomain && bid.adomain.length > 0 ? bid.adomain.join(', ') : null,
          title: null,
          image: null,
        }
        if (bid.adm) {
          try {
            const adm = typeof bid.adm === 'string' ? JSON.parse(bid.adm) : bid.adm
            let assets = null
            if (adm.assets) {
              assets = adm.assets
            } else if (adm.native && adm.native.assets) {
              assets = adm.native.assets
            }
            if (assets) {
              const titleAsset = assets.find(a => a.title && a.title.text)
              const imageAsset = assets.find(a => a.img && a.img.url)
              if (titleAsset) {
                result.title = titleAsset.title.text
              }
              if (imageAsset) {
                result.image = imageAsset.img.url
              }
            }
          } catch (e) {
            // Error parsing adm
          }
        }
        return result
      } catch (e) {
        return null
      }
    },
    async getDspPartnerData() {
      const responseData = await useJwt.getDsppartner(this.$route.params.id)
      this.dsppartner = responseData.data.dsppartner || {}
      this.setBreabcrumbs()
    },
    async setBreabcrumbs() {
      this.breadcrumbItems = [
        { text: this.$t('DSP partners'), to: '/dsppartners/' },
        { text: this.dsppartner.name, to: `/dsppartners/${this.$route.params.id}` },
        { text: this.$t('logs'), active: true },
      ]
    },
  },
}
</script>

<style scoped>
.country-counts {
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  display: grid;
  gap: 5px 15px;
}

.decoded-url-result pre {
  margin: 0.5rem 0 0;
  padding: 0.75rem;
  max-height: 240px;
  overflow: auto;
  border-radius: 0.25rem;
  background: rgba(34, 41, 47, 0.04);
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
